import { GameType, TableType } from '../types';

import type { PokerCashGamesState } from './types';

export const defaultState: PokerCashGamesState = {
  isLoading: false,
  preloaded: false,
  queryError: '',
  simpleFilters: {
    activeGameType: GameType.HOLDEM,
    activeTableType: TableType.REGULAR,
    activeSliderIndex: 2
  }
};
